import { useBackgroundByContext } from '../hooks/useBackgroundByContext';

import { EnumCoverMinileagues } from '@/types/minileagues';

export const CoverImage = ({
  context = EnumCoverMinileagues.Prize,
  position,
  prize,
}: {
  context: EnumCoverMinileagues;
  position?: number;
  prize?: string;
}) => {
  const data = useBackgroundByContext({ context, position, prize });

  return (
    <div
      className="flex items-center lg:justify-center w-full h-[83px] lg:h-[142px] text-white bg-center bg-cover bg-no-repeat rounded-lg my-4"
      style={{
        backgroundPosition: 'right 70%',
        backgroundImage: `url(${data?.src})`,
      }}
    >
      <div className="px-5 text-left lg:text-center font-bebas uppercase text-xl lg:text-2xl leading-[22px] font-normal lg:font-light lg:leading-6">
        <h2>{data?.title}</h2>
      </div>
    </div>
  );
};
